/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_area_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Because an acre was originally defined as the area a team of oxen could plow in a day — 1 furlong (660 ft) by 1 chain (66 ft) — not designed around the metric system. That historical origin is why it converts to an irregular 4,046.86 m² instead of a clean number.`)
};

const es_uc_area_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porque un acre fue originalmente definido como el área que un equipo de bueyes podría arar en un día — 1 furlong (660 pies) por 1 cadena (66 pies) — no fue diseñado alrededor del sistema métrico. Ese origen histórico es por qué se convierte a un irregular 4,046.86 m² en lugar de un número limpio.`)
};

const de_uc_area_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weil ein Acre ursprünglich als die Fläche definiert war, die ein Ochsengespann an einem Tag pflügen konnte — 1 Furlong (660 ft) mal 1 Chain (66 ft) —, nicht um das metrische System herum entworfen. Dieser historische Ursprung ist der Grund, warum er sich zu unregelmäßigen 4,046.86 m² umrechnet statt zu einer glatten Zahl.`)
};

const nl_uc_area_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Omdat een acre oorspronkelijk werd gedefinieerd als de oppervlakte die een ossenspan in een dag kon ploegen — 1 furlong (660 ft) bij 1 ketting (66 ft) — niet ontworpen rond het metrische stelsel. Die historische oorsprong is waarom het converteert naar een onregelmatige 4.046,86 m² in plaats van een schoon getal.`)
};

const fr_uc_area_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parce qu'un acre a été défini à l'origine comme la superficie qu'une équipe de bœufs pouvait labourer en un jour — 1 furlong (660 pi) par 1 chaîne (66 pi) — non conçu autour du système métrique. Cette origine historique est pourquoi il se convertit en un 4 046,86 m² irrégulier au lieu d'un nombre net.`)
};

const it_uc_area_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perché un acro era originariamente definito come l'area che un team di buoi potrebbe arare in un giorno — 1 furlong (660 ft) per 1 catena (66 ft) — non progettato attorno al sistema metrico. Questa origine storica è il motivo per cui si converte a un irregolare 4.046,86 m² invece di un numero pulito.`)
};

const pt_br2_uc_area_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porque um acre foi originalmente definido como a área que uma equipe de bois podia arar em um dia — 1 furlong (660 ft) por 1 corrente (66 ft) — não projetado em torno do sistema métrico. Essa origem histórica é por que ele se converte para um 4.046,86 m² irregular em vez de um número limpo.`)
};

const pt_uc_area_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porque um acre foi originalmente definido como a área que uma equipa de bois podia arar num dia — 1 furlong (660 ft) por 1 corrente (66 ft) — não foi concebido em torno do sistema métrico. Essa origem histórica é porque converte para um irregular 4046,86 m² em vez de um número limpo.`)
};

const ja_uc_area_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エーカーは元々、チームの牛が1日で耕すことができる区域として定義されました — 1ファーロング(660フィート)×1チェーン(66フィート) — メートル法の周りに設計されたのではなく。その歴史的な起源は、なぜきれいな数の4,046.86 m² の代わりに不規則な4,046.86 m²に変換されるかです。`)
};

const zh_uc_area_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[pending translation B]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_area_faq3_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_area_faq3_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_area_faq3_a", locale)
	if (locale === "en") return en_uc_area_faq3_a(inputs)
	if (locale === "es") return es_uc_area_faq3_a(inputs)
	if (locale === "de") return de_uc_area_faq3_a(inputs)
	if (locale === "nl") return nl_uc_area_faq3_a(inputs)
	if (locale === "fr") return fr_uc_area_faq3_a(inputs)
	if (locale === "it") return it_uc_area_faq3_a(inputs)
	if (locale === "pt-BR") return pt_br2_uc_area_faq3_a(inputs)
	if (locale === "pt") return pt_uc_area_faq3_a(inputs)
	if (locale === "ja") return ja_uc_area_faq3_a(inputs)
	return zh_uc_area_faq3_a(inputs)
};